<template>
  <div :id="chartID" style="width: 1024px;height: 500px;margin: 0 auto"></div>
</template>

<script>
import 'zrender/lib/svg/svg'
export default {
  name: 'Chart',
  props: ['options', 'chartID'],
  data: function () {
    return {
      chartP: null,
      mychart: null
    }
  },
  mounted () {
    this.chartP = document.getElementById('searchResult')
    this.mychart = this.echarts.init(document.getElementById(this.chartID), null, {renderer: 'svg'})
    this.draw()
    console.log(this.echarts.version)
  },
  watch: {
    options: function () {
      this.draw()
    }
  },
  methods: {
    draw: function () {
      this.chartResize()
      this.mychart.setOption(this.options)
    },
    chartResize: function () {
      // let myChartContainerNode = document.getElementById(this.chartID)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Chart.vue